import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home.vue";
import Login from "../components/Login.vue";
import DatabaseViewing from "../components/DeviceHistory.vue";
import Gate from "../components/Gate.vue";
import DeviceInfo from "../components/DeviceInfo.vue";
import UploadLabSheet from "../components/UploadLabSheet.vue";
import UserDeviceManager from "../components/UserDeviceManager.vue";
import AllDeviceResults from "../components/AllDeviceResults.vue";

const routes = [
  {
    path: '/home',
    name: 'Home',
    component: Home
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/device-login-history',
    name: 'DatabaseViewing',
    component: DatabaseViewing
  },
  {
    path: '/gate',
    name: 'Gate',
    component: Gate
  },
  {
    path: '/device-info',
    name: 'DeviceInfo',
    component: DeviceInfo
  },
  {
    path: '/upload-lab-sheet',
    name: 'UploadLabSheet',
    component: UploadLabSheet
  },
  {
    path: '/UserDeviceManager',
    name: 'UserDeviceManager',
    component: UserDeviceManager
  },
  {
    path: '/all-device-results',
    name: 'AllDeviceResults',
    component: AllDeviceResults
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router;